export default __webpack_public_path__ + "static/media/img_3102.cf19ee59.jpg";